module.exports = __webpack_public_path__ + "img/meat-segment.65b9b7ef.png";